const questionsData = {
    "7": {
      "Semester (5)": {
        "Foundation Engineering":[
            {
                "title": "What is a slope in geotechnical engineering?",
                "answer": "A slope is an inclined surface in natural material or ground, generally measured by its degree of inclination with respect to the horizontal. An exposed ground surface that stands at an angle with the horizontal is called an unrestrained slope."
              },
              {
                "title": "What is slope stability?",
                "answer": "Slope stability refers to the resistance of an inclined surface to failure by sliding or collapsing."
              },
              {
                "title": "What are natural slopes?",
                "answer": "Natural slopes are those formed by natural processes, such as hillsides, valleys, coastal and river cliffs, and exist without human intervention."
              },
              {
                "title": "What are man-made or artificially engineered slopes?",
                "answer": "Man-made slopes are artificially created due to engineering activities like highway cuttings, embankments, earth dams, temporary excavations, landfills, and landscaping."
              },
              {
                "title": "What is an infinite slope?",
                "answer": "An infinite slope is a slope with constant inclination that extends for a considerable length and is represented by average soil conditions on all verticals. Example: mountain or hill faces."
              },
              {
                "title": "What is a finite slope?",
                "answer": "A finite slope is limited in extent and connects two points of different elevations. Example: embankments and earth dams."
              },
              {
                "title": "Why is slope stability important?",
                "answer": "Slope stability is crucial for the safe design and construction of structures like earth dams, embankments, and landfills. Instability can lead to catastrophic failures, property damage, and loss of life."
              },
              {
                "title": "What is slope failure?",
                "answer": "Slope failure is the collapse or sliding of a slope due to insufficient shear strength to resist gravitational and other disturbing forces."
              },
              {
                "title": "What are the causes of slope failure?",
                "answer": "Causes include gravity, seepage forces, sudden drawdown, earthquakes, erosion, excavation at toe, geological features, rainfall, external loading, and pore water pressure."
              },
              {
                "title": "What is the Factor of Safety (FS) in slope stability?",
                "answer": "The Factor of Safety (FS) is defined as FS = Resisting Force (FR) / Driving Force (FD). A slope is stable if FS > 1."
              },
              {
                "title": "What are driving and resisting forces in slope stability?",
                "answer": "Driving forces (actuating forces) are components of gravity, seepage, and earthquake forces that induce shear stress. Resisting forces include the shear strength of soil and contributions from natural factors like roots."
              },
              {
                "title": "What is slope stability analysis?",
                "answer": "Slope stability analysis involves calculating shear stresses on the potential rupture surface and comparing them with the soil’s shear strength to evaluate slope safety."
              },
              {
                "title": "What is rotational failure in slopes?",
                "answer": "Rotational failure occurs when a mass of soil moves downward and outward along a curved slip surface, commonly circular in homogeneous soil and non-circular in heterogeneous soil."
              },
              {
                "title": "What is toe failure?",
                "answer": "Toe failure occurs when the slip surface passes through the toe of the slope."
              },
              {
                "title": "What is slope failure (in rotational context)?",
                "answer": "It occurs when the slip surface intersects the slope face above the toe."
              },
              {
                "title": "What is base failure?",
                "answer": "Base failure occurs when the slip surface passes well below the toe, often affecting the base of the slope."
              },
              {
                "title": "What is translational failure?",
                "answer": "Translational failure happens when soil slides along a planar surface, often occurring in infinite slopes or layered soils."
              },
              {
                "title": "What is compound failure?",
                "answer": "Compound failure is a mix of rotational and translational failures, with a curved slip surface at both ends and a planar section in the middle."
              },
              {
                "title": "What is wedge failure?",
                "answer": "Wedge failure, or plane/block failure, occurs when distinct blocks or wedges of soil slide along inclined planes, separating from the main soil mass."
              },
              {
                "title": "What are miscellaneous failures?",
                "answer": "Miscellaneous failures include complex slope failures such as spreads and flows that don’t fall into standard categories."
              },
              {
                "title": "What are some geological factors that cause slope failure?",
                "answer": "Geological features like soil stratification, weak soil layers, and underground voids can lead to slope failure."
              },
              {
                "title": "How does water contribute to slope failure?",
                "answer": "Water contributes by saturating and softening soil, entering cracks, increasing pore water pressure, and causing erosion, all of which reduce shear strength."
              },
              {
                "title": "What is the formula for Factor of Safety in block movement?",
                "answer": "FS = µsN / F, where µsN is the resisting force (FR) and F is the disturbing force (FD)."
              },
              {
                "title": "What is slope stability in geotechnical engineering?",
                "answer": "Slope stability refers to the ability of a slope to resist movement or failure. It involves analyzing the forces acting on soil or rock and ensuring the resisting forces exceed the driving forces."
              },
              {
                "title": "What are infinite slopes?",
                "answer": "Infinite slopes are those with a constant slope angle that extends over a long distance, with uniform soil properties along vertical lines. These often represent natural hillsides or embankments."
              },
              {
                "title": "What are finite slopes?",
                "answer": "Finite slopes are limited in extent and typically occur in embankments or dams. The geometry and soil properties may vary significantly along the slope."
              },
              {
                "title": "What is the factor of safety (FoS) in slope stability?",
                "answer": "FoS = Resisting Forces / Driving Forces. It indicates the stability margin of a slope. A FoS greater than 1 means the slope is stable."
              },
              {
                "title": "What causes slope failure?",
                "answer": "Slope failure can result from gravity, seepage, earthquakes, erosion, external loading, construction activity, or unfavorable geological conditions."
              },
              {
                "title": "What is rotational failure?",
                "answer": "Rotational failure involves the downward and outward movement of soil along a curved slip surface, often circular in homogeneous soil."
              },
              {
                "title": "What is translational failure?",
                "answer": "Translational failure occurs when a soil mass slides along a planar surface, typically in layered soils or infinite slopes."
              },
              {
                "title": "What is wedge failure?",
                "answer": "Wedge failure happens when distinct blocks or wedges of soil slide along an inclined plane due to separation from the main soil mass."
              },
              {
                "title": "What is Taylor’s Stability Number?",
                "answer": "Taylor’s Stability Number (Sn) = c / (γH * N), where c is cohesion, γ is unit weight, H is slope height, and N is a stability factor determined from charts."
              },
              {
                "title": "How is FoS for cohesive soil slope calculated?",
                "answer": "For cohesive soil: FoS = c / (γH * Sn), where Sn is taken from Taylor’s chart based on slope angle and failure type."
              },
              {
                "title": "What is Bishop's Method?",
                "answer": "Bishop's method is a rigorous technique for analyzing slope stability by dividing the soil mass into vertical slices and computing equilibrium considering inter-slice forces."
              },
              {
                "title": "What is the formula for shear strength of soil?",
                "answer": "Shear Strength τ = c + σ tan(φ), where c is cohesion, σ is normal stress, and φ is the angle of internal friction."
              },
              {
                "title": "How is weight of a soil wedge calculated?",
                "answer": "Weight W = γ × A, where A is the cross-sectional area of the wedge and γ is the unit weight of the soil."
              },









              {
                title: "What is the critical slip surface?",
                answer: "The critical slip surface is the surface along which the factor of safety is minimum, representing the most likely failure path."
              },
              {
                title: "What are the types of slope failures?",
                answer: "Types include toe failure, slope failure, base failure, translational failure, wedge failure, compound failure, and miscellaneous failures like flows or spreads."
              },
              {
                title: "What is a toe failure?",
                answer: "Toe failure occurs when the slip surface passes through the toe of the slope, often in shallow or homogeneous slopes."
              },
              {
                title: "What is base failure?",
                answer: "Base failure occurs when the failure surface passes below the base of the slope, usually involving deep soil layers."
              },
              {
                title: "What is a compound failure?",
                answer: "Compound failure combines both rotational and translational features, with a curved surface near the edges and a planar portion in the center."
              },
              {
                title: "How is slope failure analyzed using the Swedish Circle Method?",
                answer: "The Swedish Circle (or method of slices) divides the slip mass into vertical slices and calculates moments and forces to find the factor of safety."
              },
              {
                title: "What is the impact of pore water pressure on slope stability?",
                answer: "Pore water pressure reduces effective stress and shear strength, decreasing slope stability and increasing the likelihood of failure."
              },
              {
                title: "What is the significance of groundwater in slope stability?",
                answer: "Groundwater affects stability by adding weight, creating pore pressure, and generating seepage forces, all contributing to potential slope failure."
              },
              {
                title: "Under what conditions is the stability of earth dam slopes checked?",
                answer: "Stability of slopes in earth dams is checked under four conditions: (1) Downstream slope under steady seepage, (2) Upstream slope under sudden drawdown, (3) Both slopes during and immediately after construction, and (4) Upstream slope under submerged conditions."
              },
              {
                title: "What happens during steady seepage in an earth dam?",
                answer: "During steady seepage, water starts seeping through the dam, forming a defined phreatic line. Soil below the phreatic line becomes saturated and develops pore water pressure, affecting slope stability."
              },
              {
                title: "Why is the downstream slope more critical during steady seepage?",
                answer: "Seepage forces on the downstream (d/s) slope act outward, aiding gravity forces and reducing stability, making it more critical than the upstream slope, where seepage acts inward and adds to stability."
              },
              {
                title: "How is pore water pressure considered in slope stability analysis?",
                answer: "Pore water pressure is included when effective shear strength parameters are used. Diagrams showing pore pressure along trial slip surfaces are developed to modify the equations in Bishop’s and ordinary methods of slices."
              },
              {
                title: "How is pore water pressure (u) calculated during steady seepage?",
                answer: "Pore water pressure is calculated using the formula: u = h × γw, where h is the pressure head and γw is the unit weight of water."
              },
              {
                title: "How does the phreatic line affect slice weights in stability analysis?",
                answer: "The soil above the phreatic line uses bulk density, while below it uses saturated density. Pore pressure reduces the effective normal force, which is used to compute shear strength in slope stability analysis."
              },
              {
                title: "What is the modified factor of safety equation in Bishop's method?",
                answer: "The modified Bishop’s equation includes pore pressure term u and uses the pore pressure ratio ru(n) to simplify analysis under steady-state seepage, assuming homogeneous pore pressure distribution."
              },
              {
                title: "What is the pore pressure ratio (ru)?",
                answer: "Pore pressure ratio ru is a non-dimensional quantity representing the ratio of pore pressure to the vertical total stress. It is often taken as a constant for homogeneous soil in steady-state seepage conditions."
              },
              {
                title: "What is the Bishop and Morgenstern method?",
                answer: "The Bishop and Morgenstern method uses precomputed charts or tables with parameters like c/γH, D, φ', and β to find stability coefficients m and n, which are used to calculate the factor of safety under seepage."
              },
              {
                title: "What is the impact of sudden drawdown on slope stability?",
                answer: "During sudden drawdown, the water pressure acting on the slope is rapidly removed, but internal pore pressures remain. This imbalance reduces stability and may cause slope failure, especially in low-permeability soils."
              },
              {
                title: "How is pore pressure estimated after sudden drawdown?",
                answer: "Pore pressure is estimated using Skempton’s pore pressure parameters and the formula: u = γ × [h + h*(1 - B) - h1], where B is the pore pressure coefficient (often taken as 1)."
              },
              {
                title: "What is the drawdown ratio?",
                answer: "Drawdown ratio is defined as the change in water level during drawdown divided by the height of the slope. It is used in Morgenstern’s charts to estimate stability under rapid drawdown."
              },
              {
                title: "What is the Morgenstern method for rapid drawdown?",
                answer: "The Morgenstern method applies Bishop’s method with assumptions like a simple homogeneous slope, impermeable base, initial full submergence, and undissipated pore pressure. It uses drawdown charts for Fs estimation."
              },









              {
                title: "What is Rankine's active earth pressure coefficient?",
                answer: `Ka = (1 - sinφ) / (1 + sinφ)
            - **Ka**: Coefficient of active earth pressure
            - **φ (phi)**: Angle of internal friction of the soil`
              },
              {
                title: "What is Rankine's passive earth pressure coefficient?",
                answer: `Kp = (1 + sinφ) / (1 - sinφ)
            - **Kp**: Coefficient of passive earth pressure
            - **φ (phi)**: Angle of internal friction of the soil`
              },
              {
                title: "What is the expression for active earth pressure (dry cohesionless soil)?",
                answer: `pa = Ka × γ × h
            - **pa**: Active pressure at depth h
            - **Ka**: Active earth pressure coefficient
            - **γ (gamma)**: Unit weight of soil
            - **h**: Depth from ground surface`
              },
              {
                title: "What is the expression for passive earth pressure (dry cohesionless soil)?",
                answer: `pp = Kp × γ × h
            - **pp**: Passive pressure at depth h
            - **Kp**: Passive earth pressure coefficient
            - **γ (gamma)**: Unit weight of soil
            - **h**: Depth from ground surface`
              },
              {
                title: "How is total thrust calculated for active earth pressure?",
                answer: `Pa = (1/2) × Ka × γ × H²
            - **Pa**: Total active thrust
            - **Ka**: Active earth pressure coefficient
            - **γ**: Unit weight of soil
            - **H**: Height of retaining wall`
              },
              {
                title: "How is total thrust calculated for passive earth pressure?",
                answer: `Pp = (1/2) × Kp × γ × H²
            - **Pp**: Total passive thrust
            - **Kp**: Passive earth pressure coefficient
            - **γ**: Unit weight of soil
            - **H**: Height of retaining wall`
              },
              {
                title: "What is the effect of cohesion in Rankine’s theory?",
                answer: `Active: p = Kγh - 2c√K
            Passive: p = Kγh + 2c√K
            - **K**: Earth pressure coefficient (Ka or Kp)
            - **γ**: Unit weight of soil
            - **h**: Depth
            - **c**: Cohesion`
              },
              {
                title: "What is the formula for depth of tension crack in cohesive backfill?",
                answer: `ht = (2c) / (γ × √Ka)
            - **ht**: Depth of tension crack
            - **c**: Cohesion
            - **γ**: Unit weight of soil
            - **Ka**: Active pressure coefficient`
              },
              {
                title: "What is earth pressure at rest?",
                answer: `p0 = K0 × γ × h
            - **p0**: Pressure at rest
            - **K0**: Coefficient of earth pressure at rest
            - **γ**: Unit weight
            - **h**: Depth`
              },
              {
                title: "How is surcharge load pressure calculated?",
                answer: `ps = Ka × q
            - **ps**: Additional pressure due to surcharge
            - **Ka**: Active coefficient
            - **q**: Surcharge load`
              },
              {
                title: "How is sliding resistance checked?",
                answer: `Fr = μ × N ; Fs = Fr / Ph
            - **Fr**: Sliding resistance
            - **μ**: Coefficient of friction
            - **N**: Vertical force
            - **Ph**: Horizontal pressure
            - **Fs**: Factor of safety (≥ 1.5)`
              },
              {
                title: "How is tension at base checked?",
                answer: `pmax = (W / B) × (1 + 6e / B)
            - **pmax**: Max pressure at base
            - **W**: Total weight
            - **B**: Base width
            - **e**: Eccentricity`
              },
              {
                title: "How is bearing pressure checked?",
                answer: `pmax = (W / B) × (1 + 6e / B)
            Check: pmax ≤ q_allowable
            - **pmax**: Maximum pressure
            - **q_allowable**: Allowable bearing capacity`
              },
              {
                title: "What is the formula for resisting moment against overturning?",
                answer: `Mr = Σ(Wi × xi)
            - **Mr**: Resisting moment
            - **Wi**: Vertical forces
            - **xi**: Lever arms from toe`
              },
              {
                title: "How does water table affect lateral earth pressure?",
                answer: `p = p_soil + γw × h
            - **p_soil**: Earth pressure using γ′
            - **γw**: Unit weight of water
            - **h**: Depth below water table`
              },













              {
                title: "What are the components of active earth pressure?",
                answer: "Includes pressure from backfill weight, surcharge, and pore water. Resultant force acts at 1/3 H from base. For Rankine: \( P_a = \\frac{1}{2}K_a \\gamma H^2 \)."
              },
              {
                title: "What are mechanically stabilized earth (MSE) walls?",
                answer: "These walls use horizontal reinforcing strips (metal or geosynthetics) embedded in compacted fill. They transfer earth pressure to reinforcement for stability."
              },
              {
                title: "What is bearing capacity?",
                answer: "Bearing capacity is the capacity of soil to support the loads applied to the ground. It refers to the maximum contact pressure a foundation can sustain without failure."
              },
              {
                title: "What is Meyerhof’s bearing capacity theory?",
                answer: "Meyerhof (1951) proposed a general theory for strip footings considering shear strength above the base. It introduces shape, depth, and inclination factors and applies to both shallow and deep foundations."
              },
              {
                title: "What is the failure mechanism in Meyerhof's theory?",
                answer: "It includes three zones: elastic equilibrium (ABC), radial shear (BCD), and mixed shear (BDEF). The failure surface is logarithmic and extends above the footing base."
              },
              {
                title: "What is Hansen's bearing capacity theory?",
                answer: "Hansen (1970) extended Meyerhof's theory by adding base and ground inclination factors, and assumed a smooth base. It gives accurate results for cohesive soils."
              },
              {
                title: "What is Vesic's bearing capacity theory?",
                answer: "Vesic (1973) used a similar failure surface to Terzaghi but modified bearing capacity factors and assumptions for more accuracy, especially in the elastic wedge zone."
              },
              {
                title: "What is the general form of the ultimate bearing capacity equation?",
                answer: "It is: \( q_u = cN_c + qN_q + 0.5\\gamma BN_\\gamma \), where Nc, Nq, and Nγ are bearing capacity factors, and c, q, γ, B are cohesion, surcharge, unit weight, and width of footing."
              },
              {
                title: "How are Meyerhof's shape, depth, and inclination factors defined?",
                answer: "They are empirical modifiers applied to the basic bearing capacity formula to account for footing shape, depth of embedment, and inclined loading. Meyerhof also recommends using modified friction angle \( \\phi_r = (1.1 - 0.1\\frac{B}{L})\\phi \)."
              },
              {
                title: "What is the IS code method for bearing capacity?",
                answer: "As per IS 6403-1981, bearing capacity is calculated using modified Terzaghi-like equations, incorporating water table corrections, load eccentricity, and soil type."
              },
              {
                title: "How does the water table affect bearing capacity?",
                answer: "If water table is below Df + B, W' = 1. If at base, W' = 0.5. For intermediate depths, W' is interpolated linearly. Water table reduces effective stress and bearing capacity."
              },
              {
                title: "What is local shear failure and how is it considered?",
                answer: "Local shear failure occurs in loose or soft soils. Mobilized friction angle \( \\phi_m \) is used: \( \\tan\\phi_m = \\frac{2}{3}\\tan\\phi \). Bearing capacity factors are adjusted accordingly."
              },
              {
                title: "How is eccentricity considered in bearing capacity?",
                answer: "Eccentric vertical loads reduce effective footing width. If e > B/6, tension may develop. Effective width B' = B - 2e is used in design equations."
              },
              {
                title: "What are the safety factors used in bearing capacity design?",
                answer: "Typically, factor of safety for ultimate bearing capacity is 2.5 to 3.0. Safety factors are also applied for sliding, overturning, and settlement control."
              },
              {
                title: "How is bearing capacity estimated using SPT N-values?",
                answer: "SPT N-values are averaged over depth (1.5–2B). High outlier N-values (>50% above mean) are discarded. Empirical charts (e.g., Peck et al.) or IS 6403-1981 formulas are used to determine bearing capacity."
              },
              {
                title: "How is bearing capacity estimated using CPT values?",
                answer: "CPT cone resistance qc (from IS:4968 Part-III) is used to empirically estimate bearing capacity. Corrections are applied, and values are averaged over foundation depth."
              },
              {
                title: "What is the difference between general shear and local shear failure?",
                answer: "General shear occurs in dense/stiff soils with distinct failure surfaces and high load capacity. Local shear occurs in loose/soft soils with gradual deformation and lower load capacity."
              },
              {
                title: "When to use Terzaghi, Meyerhof, Hansen, or Vesic methods?",
                answer: "Terzaghi is simple and used for shallow strip footings. Meyerhof adds correction factors and works for deeper foundations. Hansen includes slope/inclination effects. Vesic modifies wedge assumptions and is often more precise."
              },
              {
                title: "Why is depth of foundation important?",
                answer: "Depth of foundation affects bearing capacity, protects against moisture variation, erosion, frost action, and ensures stability. Footings are placed below problematic zones and organic topsoil."
              },
              {
                title: "What is the minimum depth of foundation as per IS:1904-1986?",
                answer: "The minimum recommended depth is 0.5 m, but it is conventionally taken as 0.9 m to ensure stability and avoid seasonal effects."
              },
              {
                title: "Why should foundations be placed below filled-up soil or dump material?",
                answer: "To avoid excessive settlement due to compressible and heterogeneous nature of dumped waste or fill, the foundation should be placed below it."
              },
              {
                title: "What is the effect of groundwater on foundation depth?",
                answer: "Groundwater reduces soil bearing capacity and may require larger footings. Pumping is needed during construction, increasing cost. Hence, foundations should be above GWT when feasible."
              },
              {
                title: "What is the frost depth criterion?",
                answer: "In cold regions, foundations must be below frost depth to avoid frost heave damage. This is generally not a concern in tropical countries like India except in the Himalayas."
              },
              {
                title: "What is the active zone and why is it important in black cotton soils?",
                answer: "The active zone (1.5–2.5 m depth) experiences seasonal moisture changes causing volume variation. Foundations should be below this to avoid damage from swelling and shrinkage."
              },
              {
                title: "What does IS:1904 recommend for foundations near existing structures or slopes?",
                answer: "The slope between adjacent footings should not be steeper than 2H:1V in both granular and clayey soils. Load distribution should not intersect sloped ground."
              },
              {
                title: "What is scour depth and grip length?",
                answer: "For bridges, foundations should be located below maximum scour depth plus the required grip length below HFL to prevent undermining during floods."
              },
              {
                title: "What loads are considered in shallow foundation design as per IS:1904?",
                answer: "Load combinations: Dead + Live, or Dead + Live + Wind/Seismic. For cohesive soils, only 50% of live load is used due to time-dependent settlement."
              },
              {
                title: "How is seismic loading handled in foundation design?",
                answer: "If wind/seismic load ≥ 25% of Dead + Live, bearing pressure must not exceed SBC by more than 25%. Seismic checks include liquefaction and settlement (IS:1893-2002)."
              },
              {
                title: "What are preferred footing shapes for various loading conditions?",
                answer: "Square footings are preferred for vertical loads. Rectangular footings are better for columns with moments due to their longer projection."
              },
              {
                title: "What are the FOS for sliding and overturning in shallow foundations?",
                answer: "FOS ≥ 1.75 for sliding and ≥ 2.0 for overturning. If seismic/wind loads are considered, FOS ≥ 1.5 for both."
              },
              {
                title: "What is the minimum width of wall foundation?",
                answer: "It should be at least equal to wall thickness + 30 cm, with proper angular load spread depending on material used (e.g., 2V:1H for masonry)."
              },
              {
                title: "What is a strip (wall) footing?",
                answer: "A continuous footing under load-bearing walls or closely spaced columns. Economical when individual spread footings overlap or nearly touch."
              },
              {
                title: "What is a spread or isolated footing?",
                answer: "Supports an individual column. May be square, circular, or rectangular. Used when loads are low and columns are widely spaced."
              },
              {
                title: "What is a combined footing?",
                answer: "Supports two or more columns when isolated footings would overlap or extend beyond the property line. May be rectangular, trapezoidal, or strap-beam types."
              },
              {
                title: "When is rectangular vs. trapezoidal combined footing used?",
                answer: "Use rectangular when column loads are similar. Use trapezoidal when one column carries a significantly larger load."
              },
              {
                title: "What is a strap footing?",
                answer: "Connects an eccentrically loaded exterior column footing to an interior column footing with a strap beam to equalize pressure distribution."
              },
              {
                title: "What is a mat or raft foundation?",
                answer: "A large continuous slab supporting all columns/walls in a structure. Used for soft soils, basements, and where differential settlement is a concern."
              },
              {
                title: "What is a ring or annular footing?",
                answer: "Used for circular structures like silos, chimneys, and tanks. Transfers load through the ring wall into soil, resisting overturning and settlement."
              },
              {
                title: "Why is the depth of foundation important?",
                answer: "Depth ensures stability by increasing bearing capacity, avoiding moisture variation, frost heave, erosion, and placing footing in more competent soil."
              },
              {
                title: "What is the minimum embedment depth as per IS:1904-1986?",
                answer: "IS:1904-1986 recommends a minimum depth of 0.5 m, but conventionally 0.9 m is preferred for better performance."
              },
              {
                title: "Why should topsoil be removed before placing foundation?",
                answer: "Topsoil contains organic material and loose fill, which is unsuitable for supporting structural loads. It must be replaced with compacted fill or the foundation should be taken deeper."
              },
              {
                title: "How does the type of structure affect foundation depth?",
                answer: "For heavy or important structures, foundations must reach hard soil or rock to avoid settlement and structural failure."
              },
              {
                title: "What is the effect of groundwater on foundation design?",
                answer: "Groundwater reduces soil strength and bearing capacity. It increases construction cost due to dewatering and may require deeper or wider foundations."
              },
              {
                title: "What is the significance of frost depth?",
                answer: "In cold climates, foundations must be placed below the frost line to prevent heaving. In India, this applies mainly to Himalayan regions."
              },
              {
                title: "Why is foundation depth below the active zone important in clayey soils?",
                answer: "To avoid volume change effects from seasonal moisture variations in expansive clays, foundations are placed below the active zone (1.5–2.5 m)."
              },
              {
                title: "What are IS:1904-1986 guidelines for foundations near slopes or adjacent structures?",
                answer: "For granular and clayey soils, the line connecting adjacent foundations should not exceed a slope of 2H:1V to avoid load interference or stress overlaps."
              },
              {
                title: "What is the minimum edge distance for footing on sloping ground?",
                answer: "A minimum of 60 to 90 cm is required from the edge to protect the footing from erosion and maintain stability."
              },
              {
                title: "What is scour depth and grip length for bridge foundations?",
                answer: "Foundations should extend below the maximum scour depth plus a safety grip length to resist hydraulic forces."
              },








  {
    title: "What are typical load combinations used in foundation design?",
    answer: "Dead Load + Live Load; Dead Load + Live Load + Wind/Seismic. In cohesive soils, 50% of live load is considered due to delayed settlement behavior."
  },
  {
    title: "How are seismic loads considered in foundation design?",
    answer: "If Seismic Load ≥ 25% of (Dead + Live Load), soil pressure may exceed SBC by 25%. Consider liquefaction and settlement checks per IS:1893-2002."
  },
  {
    title: "What is the preferred shape of footings for different load types?",
    answer: "Square footings: for vertical loads. Rectangular footings: for moments or eccentric loads (economical and effective)."
  },
  {
    title: "What are minimum FOS requirements for foundation safety?",
    answer: "Sliding: FOS ≥ 1.75; Overturning: FOS ≥ 2.0. With wind/seismic loads: FOS = 1.5 for both."
  },
  {
    title: "What is the minimum wall foundation width?",
    answer: "Minimum width = Wall thickness + 30 cm."
  },
  {
    title: "What angular spread is considered for unreinforced foundations?",
    answer: "Masonry: 2V:1H, Lime Concrete: 3V:2H, Cement Concrete: 1V:1H."
  },
  {
    title: "What is immediate settlement (Se)?",
    answer: "Elastic deformation under load, mostly in granular soils.\nFormula:\nSe = (q × B × If) / Es\nWhere:\nq = net foundation pressure (kN/m²)\nB = footing width (m)\nIf = influence factor (depends on shape and depth)\nEs = modulus of elasticity of soil (kN/m²)"
  },
  {
    title: "What is primary consolidation settlement (Sc)?",
    answer: "Occurs in saturated clays due to gradual expulsion of water.\nFormula:\nSc = (Cc / (1 + e0)) × H × log10(p1/p0)\nWhere:\nCc = compression index\ne0 = initial void ratio\nH = thickness of compressible soil layer (m)\np1 = final effective stress\np0 = initial effective stress"
  },
  {
    title: "What is secondary consolidation settlement (Ss)?",
    answer: "Occurs after primary consolidation due to soil particle adjustment.\nFormula:\nSs = Cα × H × log10(t2/t1)\nWhere:\nCα = secondary compression index\nH = thickness of soil layer\nt1 = time at end of primary consolidation\nt2 = time after primary consolidation"
  },
  {
    title: "How is settlement depth corrected?",
    answer: "Corrected Settlement = Surface Settlement × Depth Factor\n(Depth Factor from IS:8009 or Fox’s charts)"
  },
  {
    title: "What is rigidity correction for rigid foundations?",
    answer: "Rigid Foundation Settlement = Flexible Settlement × 0.8\n(0.8 is typical rigidity factor)"
  },
  {
    title: "What is Schmertmann's method for immediate settlement in sand?",
    answer: "Semi-empirical method using cone resistance.\nElastic modulus (Es):\n- Es = 2.5 × qc (for L/B < 10)\n- Es = 3.5 × qc (for L/B > 10)\n- Es = 800 × N (SPT-based estimate)\nWhere:\nqc = cone resistance (kN/m²)\nN = SPT value\nL/B = length to breadth ratio of footing"
  },
  {
    title: "What is the static cone method (SCPT) for settlement?",
    answer: "Based on average cone resistance (qc), stress increment (Δσ), and compressibility of soil layers. Settlement is calculated for each layer and summed."
  },
  {
    title: "How is settlement estimated using SPT data?",
    answer: "Use corrected SPT N-values, effective stress, and water table correction factor (W′) as per IS:8009 (Part 1) – 1976."
  },
  {
    title: "What is Plate Load Test (PLT)?",
    answer: "Field test with steel plates (30–75 cm, ≥25 mm thick). Load applied in increments and settlement observed.\nSand: terminate when settlement rate < 0.02 mm/min\nClay: wait for 70–80% of ultimate settlement"
  },
  {
    title: "How is ultimate bearing capacity from PLT determined?",
    answer: "From the load vs. settlement graph using:\n- Bilinear method\n- Log-log method\nTo find yield point or failure load"
  },
  {
    title: "How is load transfer in piles calculated (static method)?",
    answer: "Formula: Qu = qpu × Ab + fs × As\nWhere:\nQu = ultimate pile capacity (kN)\nqpu = unit base resistance (kN/m²)\nAb = base area of pile (m²)\nfs = unit skin friction (kN/m²)\nAs = surface area of pile shaft (m²)"
  },
  {
    title: "How is skin friction calculated in sands and clays?",
    answer: "Sand: fs = q′ × K × tan(δ)\nClay: fs = α × cu\nWhere:\nq′ = effective overburden pressure (kN/m²)\nK = lateral earth pressure coefficient\nd = angle of wall friction\nα = adhesion factor\ncu = undrained cohesion of clay (kN/m²)"
  },
  {
    title: "How is pile capacity calculated in granular soils (IS:2911)?",
    answer: "Qu = q′ × Nq × Ab + γ × B × Nγ × Ab\nWhere:\nq′ = effective overburden pressure\nNq, Nγ = bearing capacity factors (from IS:6403)\nγ = unit weight of soil\nB = width of pile\nAb = base area of pile"
  },
  {
    title: "How is pile capacity in cohesive soil calculated (IS:2911)?",
    answer: "Qu = α × cu × As + cu × Nc × Abg\nWhere:\nα = adhesion factor\ncu = undrained cohesion\nAs = shaft area\nNc = bearing capacity factor (typically 9)\nAbg = gross base area"
  },
  {
    title: "What is Modified Hiley formula for dynamic pile load capacity?",
    answer: "Qu = (W × h × η × α) / (S + C/2)\nWhere:\nW = hammer weight (kN)\nh = height of fall (m)\nη = hammer efficiency\nα = efficiency factor\nS = set per blow (mm)\nC = elastic compression (mm)"
  },
  {
    title: "What is group efficiency of piles?",
    answer: "ηg = Qug / (N × Qu)\nWhere:\nηg = group efficiency\nQug = ultimate group capacity\nN = number of piles\nQu = capacity of a single pile"
  },
  {
    title: "What is negative skin friction and how is it calculated?",
    answer: "Occurs when soil settles more than pile.\nClay: Fn = PLn × α × cu\nSand: Fn = 0.5 × PLn × γ × K × tan(δ)\nWhere:\nPLn = pile length\nα = adhesion factor\ncu = undrained cohesion\nγ = unit weight of soil\nK = lateral earth pressure coefficient\nd = wall friction angle"
  },
  {
    title: "How is negative skin friction for group piles calculated?",
    answer: "Fng = N × Fn OR\nFng = Pg × Ln × cu + γ × Ln × Ag\nWhere:\nFng = group friction\nPg = group perimeter\nAg = group area"
  },
  {
    title: "What is angular distortion and how is it calculated?",
    answer: "T = δ / L\nWhere:\nT = angular distortion\nδ = differential settlement (mm)\nL = distance between two points (mm or m)"
  },
  {
    title: "How is vertical pile load test evaluated (IS:2911)?",
    answer: "Allowable Load = Lesser of:\n- 2/3 of load at 12 mm settlement\n- 50% of load at 10% of pile diameter"
  },
  {
    title: "What is formula for total settlement?",
    answer: "S = Se + Sc + Ss\nWhere:\nS = total settlement\nSe = immediate settlement\nSc = primary consolidation settlement\nSs = secondary settlement"
  },
  {
    title: "How is pile group settlement calculated?",
    answer: "Settlement = Elastic compression of pile + Settlement of soil below pile tip.\nUse Sc formula with effective stress from group loading."
  }
              
        ],

      },
    },


}
    export default questionsData;
